import React, { useState } from 'react';
import { Card, Button, Input, Select, Tag, Popconfirm, message } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { addFollowup } from '../../api/students';
import api from '../../api/axios';
import useAuthStore from '../../store/authStore';
import { apiErrorMessage } from '../../utils/apiError';

const { Option } = Select;

const statusLabels = {
  pending: { label: 'Bekliyor', color: 'orange' },
  called: { label: 'Arandı', color: 'blue' },
  registered: { label: 'Kayıt Oldu', color: 'green' },
  cancelled: { label: 'İptal', color: 'red' },
};

const StudentFollowupTab = ({ studentId, followups, onUpdate }) => {
  const [text, setText] = useState('');
  const [status, setStatus] = useState('called');
  const { user: currentUser } = useAuthStore();

  const canDelete = (followup) => {
    return followup.user_id === currentUser?.id ||
      ['developer_admin', 'super_admin'].includes(currentUser?.role);
  };

  const handleAdd = async () => {
    try {
      await addFollowup(studentId, { note: text, status });
      setText('');
      message.success('Takip notu eklendi.');
      onUpdate();
    } catch (error) {
      message.error('Takip notu eklenemedi.');
    }
  };

  const handleDelete = async (followupId) => {
    try {
      await api.delete(`/students/${studentId}/followups/${followupId}`);
      message.success('Takip notu silindi.');
      onUpdate();
    } catch (error) {
      message.error(apiErrorMessage(error, 'Takip notu silinemedi.'));
    }
  };

  return (
    <Card>
      <div className="flex gap-2 mb-4">
        <Input.TextArea
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Takip notu..."
          rows={2}
        />
        <div className="flex flex-col gap-2">
          <Select value={status} onChange={setStatus} style={{ width: 130 }}>
            <Option value="pending">Bekliyor</Option>
            <Option value="called">Arandı</Option>
            <Option value="registered">Kayıt Oldu</Option>
            <Option value="cancelled">İptal</Option>
          </Select>
          <Button type="primary" onClick={handleAdd}>Ekle</Button>
        </div>
      </div>

      {followups.map((f) => (
        <div key={f.id} className="p-3 border rounded mb-2">
          <div className="flex justify-between items-start">
            <div className="flex items-center gap-2 flex-wrap">
              <Tag color={statusLabels[f.status]?.color}>
                {statusLabels[f.status]?.label}
              </Tag>
              <span className="text-gray-600 text-sm font-medium">
                {f.user?.name} {f.user?.surname}
              </span>
              <span className="text-gray-400 text-sm">
                {dayjs(f.created_at).format('DD.MM.YYYY HH:mm')}
              </span>
            </div>
            {canDelete(f) && (
              <Popconfirm
                title="Takip notunu silmek istediğinize emin misiniz?"
                onConfirm={() => handleDelete(f.id)}
                okText="Evet"
                cancelText="Hayır"
              >
                <Button icon={<DeleteOutlined />} danger size="small" />
              </Popconfirm>
            )}
          </div>
          {f.note && <p className="mt-1">{f.note}</p>}
        </div>
      ))}
      {followups.length === 0 && <p className="text-gray-400">Henüz takip notu eklenmemiş.</p>}
    </Card>
  );
};

export default StudentFollowupTab;